<div>
  <div class="tw-grid tw-grid-rows-[auto_1fr] tw-items-center tw-min-h-[69px]">

    <div class="tw-text-right tw-grid tw-grid-cols-[auto_auto] tw-p-3">
      <mat-form-field class="tw-w-auto no-pad-wrapper" appearance="outline">
      <mat-select [placeholder]="'Select Filter'" [class]="'no-arrow-transform'" [value]="(filter$|async)" (selectionChange)="setFilter($event.value)">
        <mat-option value="all">All</mat-option>
        <mat-option value="incoming">Incoming Calls</mat-option>
        <mat-option value="outgoing">Outgoing Calls</mat-option>
        <mat-option value="missed">Missed</mat-option>
        <mat-option value="voicemail">Voicemails</mat-option>
        <mat-option value="unknown">Unknown</mat-option>
      </mat-select>
      </mat-form-field>

      <mat-form-field class="tw-ml-2 tw-w-auto" appearance="outline">
      <mat-select [class]="'no-arrow-transform'" [value]="(sort$|async)" (selectionChange)="setSort($event.value)">
        <mat-option value="desc">Newest to oldest</mat-option>
        <mat-option value="asc">Oldest to newest</mat-option>
      </mat-select>
      </mat-form-field>
    </div>

    <mat-list appDynamicScreenHeight class="!tw-p-0 tw-overflow-y-auto">
      <mat-card
        class="!tw-rounded-none mat-elevation-z0 tw-border-b {{ call.id === (selectedCall$ | async)?.id ? 'active' : '' }}"
        *ngFor="let call of (history$ | async)"
        (click)="setSelection(call)">
          <div class="tw-grid tw-grid-cols-[24px_1fr] tw-gap-x-1">
            <div class="tw-grid tw-items-start">
              <mat-icon class="tw-text-base">{{ call.materialIconName }}</mat-icon>
            </div>
            <div>
              <mat-card-title
                [ngClass]="{'missed-call' : ((call.materialIconName === 'voicemail') || (call.materialIconName === 'call_missed') && (call.id != (selectedCall$| async)?.id))}"
                class="!tw-text-sm !tw-font-bold">{{ call.first}} {{ call.last }}
              </mat-card-title>
              <mat-card-subtitle 
                [ngClass]="{'missed-call' : ((call.materialIconName === 'voicemail') || (call.materialIconName === 'call_missed') && (call.id != (selectedCall$| async)?.id))}"
                class="!tw-text-xs">{{ call.fromNumber | phone }}
              </mat-card-subtitle>
              <mat-card-subtitle class="!tw-text-xs tw-absolute tw-top-6 tw-right-6">{{call.created | timeago }}</mat-card-subtitle>
              {{call.borrowerName}}
            </div>
          </div>
      </mat-card>

      <div class="tw-flex tw-p-3 tw-items-center tw-justify-center">
        <mat-spinner diameter="24" *ngIf="( historyLoading$ | async ) else nonLoadingState">
          <h1>Loading: {{ historyLoading$ | async | json }}</h1>
        </mat-spinner>

        <ng-template #nonLoadingState>
          <span *ngIf="(history$ | async).length < 1 else loadMoreButton">No call history for this filter.</span>
          <ng-template #loadMoreButton>
            <button *ngIf="(page$ | async) !== (lastPage$ | async)" mat-stroked-button [color]="'primary'" (click)="loadMore()">Load More</button>
          </ng-template>
        </ng-template>
      </div>
    </mat-list>

  </div>
</div>

<mat-divider appDynamicScreenHeight [vertical]="true"></mat-divider>

<div class="tw-grid tw-grid-flow-col tw-grid-cols-[55%_1px_1fr]">
  <div>
    <div *ngIf="!(historyLoading$ | async)" class="tw-grid tw-items-start detailsHeader tw-px-6 tw-py-4 tw-border-b detailsBorder">
      <mat-spinner *ngIf="(historyLoading$ | async)" class="tw-m-auto" diameter="48"></mat-spinner>
      <div *ngIf="!(selectedCall$ | async)" class="tw-text-center tw-mt-4"><h2>You've reached the end of the rainbow. <mat-icon>rainbow</mat-icon></h2></div>
      <div *ngIf="(selectedCall$ | async) as selectedCall" class="tw-flex tw-justify-between">
        <div>
          <div><h3>{{ selectedCall.historyType | startcase }} {{ selectedCall.historyType === 'outgoing' ? 'to' : 'from' }} {{ selectedCall.first }} {{ selectedCall.last ? selectedCall.last + " - " : '' }} {{ selectedCall.fromNumber | phone }} </h3></div>
          <div>for <b><a [routerLink]="['/borrower/' + selectedCall.borrowerId]" interactive>{{ selectedCall.borrowerName }}</a></b> {{ selectedCall.borrowerStage | startcase }}: {{ selectedCall.borrowerStatus | startcase | statusDisplay }}</div>
        </div>
        <div class="tw-flex tw-flex-col tw-items-end tw-justify-between">
          <div class="timestamp">{{ selectedCall.created | date:'MMM dd, yyyy, hh:mm a' }}</div>
          <div class="tw-flex">
            <button
              mat-stroked-button
              color="primary"
              (click)="playRecording(selectedCall.id)"
              class="voicemail-button"
              *ngIf="selectedCall.recordingUrl && selectedCall.id">
              <mat-icon>play_circle_outline</mat-icon>
              Listen
            </button>
            <app-borrower-contact-methods
              [borrowerId]="selectedCall.borrowerId"
              [borrowerStatus]="selectedCall.borrowerStatus"
            >
            </app-borrower-contact-methods>
          </div>
        </div>
      </div>
    </div>
  </div>

  <mat-divider [vertical]="true"></mat-divider>
  <app-user-action-item-borrower-pane *ngIf="(selectedCall$ | async)?.borrowerId != null else unknownBorrower"></app-user-action-item-borrower-pane>
  <ng-template #unknownBorrower>
    <div class="tw-p-4">
      <div class="tw-text-center tw-py-2 tw-bg-gray-100 tw-rounded-md">No related business detected</div>
    </div>
  </ng-template>
</div>
